import { lazy } from 'react';
// project import
import Loadable from '../../components/Loadable';
// ==============================|| ROUTES ITEMS - CAMERA ||============================== //

// render - CAMERA
const CameraPage = Loadable(lazy(() => import('../../pages/camera/CameraPage')));

const camera = {
    path: 'camera',
    element: <CameraPage />,
};

export default camera;